import { inject } from '@angular/core';
import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);

  return next(req).pipe(
    catchError((error: any) => {
      if (error instanceof HttpErrorResponse) {
        const publicPaths = ['/login', '/signup', '/cart', '/subscription'];
        const isPublicRoute = publicPaths.some((path) => router.url.startsWith(path));

        if ((error.status === 401 || error.status === 403) && !isPublicRoute) {
          localStorage.clear();
          router.navigate(['/login']);
        }
      }
      return throwError(() => error);
    })
  );
};
